import { FC, useCallback, useState } from 'react'

import { Translation } from 'cng-common/features/translations'
import { Button } from 'core-components/library/button'

import { exportBusinessPriorities } from '../../api/exportBusinessPriorities'
import { BUSINESS_PRIORITIES_TRANSLATION_KEYS as KEYS } from '../../configs/translations'

interface IBusinessPrioritiesExportButtonProps {
  fYear: number
  isDisabled?: boolean
}

export const BusinessPrioritiesExportButton: FC<IBusinessPrioritiesExportButtonProps> = ({
  fYear,
  isDisabled = false,
}) => {
  const [isExporting, setIsExporting] = useState(false)

  const onExport = useCallback(async () => {
    setIsExporting(true)

    try {
      await exportBusinessPriorities(fYear)
    } finally {
      setIsExporting(false)
    }
  }, [fYear])

  return (
    <Button
      color="primary"
      icon="kbase kbase-download"
      variant="contained"
      loading={isExporting}
      disabled={isDisabled}
      onClick={onExport}
    >
      <Translation text={KEYS.listHeader.export} />
    </Button>
  )
}

BusinessPrioritiesExportButton.displayName = 'BusinessPrioritiesExportButton'

export default BusinessPrioritiesExportButton
